import React, { useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

export default function ImageWithLoader({ 
  src, 
  alt, 
  className = '', 
  fallbackText = '?',
  iconType = 'printer',
  size = 'preview',
  onLoad,
  onError,
  ...props 
}) {
  const [imageState, setImageState] = useState('loading'); // 'loading', 'loaded', 'error'

  // Generate loading placeholder URL with animation
  const getLoadingPlaceholderUrl = () => {
    return `${API_URL}/api/icons/placeholders/${iconType}/${size}.svg`;
  };

  // Handle image load success
  const handleImageLoad = (e) => {
    setImageState('loaded');
    if (onLoad) onLoad(e);
  };

  // Handle image load error
  const handleImageError = (e) => {
    console.log('❌ Image failed to load:', e.target.src);
    setImageState('error');
    if (onError) onError(e);
  };

  // If no src provided, show placeholder immediately
  if (!src) {
    return (
      <div className={`image-placeholder text-placeholder ${className}`} {...props}>
        {fallbackText}
      </div>
    );
  }

  // Render based on current state
  if (imageState === 'loading') {
    return (
      <>
        <img
          src={getLoadingPlaceholderUrl()}
          alt={`Loading ${alt}`}
          className={`image-placeholder loading-placeholder ${className}`}
          {...props}
        />
        <img
          src={src}
          alt={alt}
          className={`image-loaded ${className}`}
          onLoad={handleImageLoad}
          onError={handleImageError}
          style={{ display: 'none' }}
          {...props}
        />
      </>
    );
  }

  if (imageState === 'error') {
    return (
      <div className={`image-placeholder error-placeholder ${className}`} {...props}>
        {fallbackText}
      </div>
    );
  }

  // Success state - show the actual image
  return (
    <img
      src={src}
      alt={alt}
      className={`image-loaded ${className}`}
      onLoad={handleImageLoad}
      onError={handleImageError}
      {...props}
    />
  );
}
